/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'navigation.global-shortcuts.all-sites': 'All sites',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Close',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(currently unavailable)',
  'navigation.global-shortcuts.sites': '{productName} sites',
};
